export default "__VITE_ASSET__2df35925__"